module.exports = __webpack_public_path__ + "img/weremit-logo.31169f56.png";